import React from 'react';
import Certification, { certificationPropTypes } from './certification';
import SubSpecialties from './sub_specialties';
import Specialties, { specialtiesPropTypes } from './specialties';
import './index.scss';
import VcardToggle from './vcard_toggle';
import PrintBrokerBioToggle from './print_broker_bio_toggle';
import Organization, { organizationPropTypes } from './organizations';
import PropTypes from 'prop-types';

export default function UserProfile(props) {
  return (
    <React.Fragment>
      <div className="mb-2">
        <VcardToggle showVcard={props.showVcardOnBrokerPlugin}/>
      </div>
      <PrintBrokerBioToggle showPrintBrokerBio={props.showPrintBrokerBioOnBrokerPlugin} />
      <hr/>
      <div className="d-flex flex-column gap-6">
        <div>
          <Certification
            allBrokerCertifications={props.allBrokerCertifications}
            showCertificationsOnBrokerPlugin={props.showCertificationsOnBrokerPlugin}
            showCertificationsOnDocuments={props.showCertificationsOnDocuments}
            showCertificationsOnEmails={props.showCertificationsOnEmails}
            showCertificationsOnInventoryPlugin={props.showCertificationsOnInventoryPlugin}
            userCertifications={props.userCertifications}
          />
        </div>
        <div>
          <Specialties
            allBrokerSpecialties={props.allBrokerSpecialties}
            showSpecialtiesOnBrokerPlugin={props.showSpecialtiesOnBrokerPlugin}
            userSpecialties={props.userSpecialties}
          />
        </div>
        <div>
          <SubSpecialties
            allSubSpecialties={props.allSubSpecialties}
            showSubSpecialtiesOnBrokerPlugin={props.showSubSpecialtiesOnBrokerPlugin}
            userSubSpecialties={props.userSubSpecialties}
          />
        </div>
        <div>
          <Organization
            allBrokerOrganizations={props.allBrokerOrganizations}
            showOrganizationsOnBrokerPlugin={props.showOrganizationsOnBrokerPlugin}
            userOrganizations={props.userOrganizations}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

UserProfile.propTypes = {
  showPrintBrokerBioOnBrokerPlugin: PropTypes.bool.isRequired,
  showVcardOnBrokerPlugin: PropTypes.bool.isRequired,
  ...certificationPropTypes,
  ...specialtiesPropTypes,
  ...organizationPropTypes,
};
